var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgTempleWallet(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 37,
    height: 36,
    viewBox: "0 0 37 36",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_1477_276812)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 18.5,
    cy: 18,
    r: 16,
    fill: "white"
  }), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1477_276812)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M22.1701 14.1515H25.4999L23.8382 8H12.168L13.8361 14.1515H17.1658L18.8339 20.3091H16.7504L17.5877 23.3819H19.6712L20.502 26.4606H25.4999L22.1701 14.1515Z",
    fill: "url(#paint0_linear_1477_276812)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.838 15.6917H22.5853L22.1699 14.1523H25.4996L23.838 15.6917Z",
    fill: "url(#paint1_linear_1477_276812)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.1709 11.0793H14.6677L14.46 10.3066H22.794L22.1709 11.0793Z",
    fill: "url(#paint2_linear_1477_276812)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.1681 15.6909L10.5 9.53938L12.1681 8L13.8362 14.1515L12.1681 15.6909Z",
    fill: "url(#paint3_linear_1477_276812)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.6715 23.3828H17.588L15.9199 24.9222H18.0034L19.6715 23.3828Z",
    fill: "url(#paint4_linear_1477_276812)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.4977 15.6917H12.168L13.8361 14.1523H17.1658L15.4977 15.6917Z",
    fill: "url(#paint5_linear_1477_276812)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.8343 20.3099H16.7508L15.498 15.6917L17.1662 14.1523L18.8343 20.3099Z",
    fill: "url(#paint6_linear_1477_276812)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.5874 23.3814L16.7501 20.3086L15.082 21.842L15.9193 24.9208L17.5874 23.3814Z",
    fill: "url(#paint7_linear_1477_276812)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.5018 26.4616L19.671 23.3828L18.0029 24.9222L18.8337 28.001L20.5018 26.4616Z",
    fill: "url(#paint8_linear_1477_276812)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.8381 26.4598L20.0865 12.6113L19.418 13.2283L23.0008 26.4598L22.3323 27.0767H23.1696L23.8381 26.4598Z",
    fill: "url(#paint9_linear_1477_276812)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.4161 12.6127H22.5853L22.1699 11.0793L22.793 10.3066L23.4161 12.6127Z",
    fill: "url(#paint10_linear_1477_276812)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.8383 26.4609L23.1698 27.0779H22.3325L23.001 26.4609H20.5021L18.834 28.0003H23.8383L25.4999 26.4609H23.8383Z",
    fill: "url(#paint11_linear_1477_276812)"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_1477_276812",
    x: 0.5,
    y: 0,
    width: 36,
    height: 36,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0.760784 0 0 0 0 1 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_1477_276812"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_1477_276812",
    result: "shape"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1477_276812",
    x1: 12.1669,
    y1: 17.2302,
    x2: 25.5029,
    y2: 17.2302,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.00188079,
    stopColor: "#FEC53C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFF050"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_1477_276812",
    x1: 25.5027,
    y1: 14.9234,
    x2: 22.1687,
    y2: 14.9234,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FD9A28"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FB6C13"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_1477_276812",
    x1: 22.7958,
    y1: 10.6927,
    x2: 14.4598,
    y2: 10.6927,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FA4200"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FB6C13"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_1477_276812",
    x1: 11.1887,
    y1: 8.22509,
    x2: 12.8696,
    y2: 15.5302,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FB6C13"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FD9A28"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_1477_276812",
    x1: 15.9179,
    y1: 24.1538,
    x2: 19.6687,
    y2: 24.1538,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FA4200"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FB6C13"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_1477_276812",
    x1: 12.1669,
    y1: 14.9234,
    x2: 17.1679,
    y2: 14.9234,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FA4200"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FB6C13"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_1477_276812",
    x1: 17.8528,
    y1: 20.5338,
    x2: 16.4243,
    y2: 14.3254,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FB6C13"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FD9A28"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint7_linear_1477_276812",
    x1: 16.8967,
    y1: 24.6962,
    x2: 15.9301,
    y2: 20.4953,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FD9A28"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FB6C13"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint8_linear_1477_276812",
    x1: 19.814,
    y1: 27.7744,
    x2: 18.8475,
    y2: 23.5735,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FB6C13"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FD9A28"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint9_linear_1477_276812",
    x1: 23.1687,
    y1: 27.0747,
    x2: 19.8538,
    y2: 12.6675,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FB6C13"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FA4200"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint10_linear_1477_276812",
    x1: 23.0894,
    y1: 12.9406,
    x2: 22.5538,
    y2: 10.6127,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FA4200"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FB6C13"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint11_linear_1477_276812",
    x1: 19.5342,
    y1: 27.2299,
    x2: 24.5149,
    y2: 27.2299,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FA4200"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FB6C13"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1477_276812"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 15,
    height: 20,
    fill: "white",
    transform: "translate(10.5 8)"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTempleWallet);
export default __webpack_public_path__ + "static/media/TempleWallet.32688f0c79e5d2998c342dd9384a94b8.svg";
export { ForwardRef as ReactComponent };